// extracted by mini-css-extract-plugin
module.exports = {"content":"PropertiesContent_content__T7Hg5","isNotAccordion":"PropertiesContent_isNotAccordion__2NP4N"};